import { render } from "./RegistrarLlave.vue?vue&type=template&id=ba744faa&scoped=true"
import script from "./RegistrarLlave.vue?vue&type=script&lang=js"
export * from "./RegistrarLlave.vue?vue&type=script&lang=js"

import "./RegistrarLlave.vue?vue&type=style&index=0&id=ba744faa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba744faa"]])

export default __exports__